import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

export const BalanceContext = createContext();

export const useBalance = () => useContext(BalanceContext);

export const BalanceProvider = ({ children }) => {
  const { currentUser } = useSelector((state) => state.user);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBalance = useCallback(async () => {
    if (!currentUser?._id) return;
    
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`/api/credit/${currentUser._id}/balance`);
      
      // Ensure the response structure matches what the controller sends
      if (res.data && typeof res.data.balance === 'number') {
        setBalance(res.data.balance);
      } else {
        throw new Error('Invalid balance data format');
      }
    } catch (err) {
      console.error('Balance fetch error:', err);
      setError(err.response?.data?.message || 'Failed to fetch balance');
      // Optionally set a default balance or keep previous value
      setBalance(0);
    } finally {
      setLoading(false);
    }
  }, [currentUser?._id]);

  useEffect(() => {
    fetchBalance();
    
    // Set up polling to refresh balance periodically (optional)
    const interval = setInterval(fetchBalance, 30000); // Refresh every 30 seconds
    
    return () => clearInterval(interval);
  }, [fetchBalance]);

  // Provide refresh function to consumers
  const contextValue = {
    balance,
    loading,
    error,
    refreshBalance: fetchBalance
  };

  return (
    <BalanceContext.Provider value={contextValue}>
      {children}
    </BalanceContext.Provider>
  );
};